import { AgoraInterface } from "@share/web-conferences/interfaces/AgoraInterface";

export class AgoraCloudProxy {
    private readonly IsUsingCloudProxyEvent = 'is-using-cloud-proxy';

    isUsingProxy = false;

    constructor(
        private readonly agora: AgoraInterface
    ) {
        this.clean();

        agora.client.on(this.IsUsingCloudProxyEvent, this.onUsingProxyChange.bind(this));
    }

    /**
     * Agora's is-using-cloud-proxy event handler, switches isUsingProxy
     * @param isUsingProxy
     */
    onUsingProxyChange(isUsingProxy: boolean) {
        this.isUsingProxy = isUsingProxy;
    }

    /**
     * Removes the event handler
     */
    clean() {
        this.agora.client.removeAllListeners(this.IsUsingCloudProxyEvent);
    }
}